import EventEmitter from 'eventemitter3';

export const helpCenterEventEmitter = new EventEmitter();
